import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import linkedinImage from '../../../assets/images/linkedin.png';

const certificates = [
  {
    title: 'Succeeding as a First-Time Tech Manager',
    issuedBy: 'LinkedIn',
    date: '7 December 2025',
    image: linkedinImage,
    link: 'https://drive.google.com/file/d/1GH7vE7X7Nzb-NtFKtegQge_ies_6z_oz/view?usp=sharing'
  },
  {
    title: 'Succeeding as a First-Time Tech Manager',
    issuedBy: 'LinkedIn',
    date: '7 December 2025',
    image: linkedinImage,
    link: 'https://drive.google.com/file/d/1ls3B1MX5ELet5Fh7aid6T4Pb30Rke9Nh/view?usp=sharing'
  },
  {
    title: 'Succeeding as a First-Time Tech Manager',
    issuedBy: 'LinkedIn',
    date: '7 December 2025',
    image: linkedinImage,
    link: 'https://drive.google.com/file/d/1pUiGouRNxSsZwiKRoes-oomLJA514uKP/view?usp=sharing'
  }
];

const LinkedInCertificates = () => {
  return (
    <CertificateDetailTemplate
      provider="LinkedIn"
      certificates={certificates}
    />
  );
};

export default LinkedInCertificates;
